import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetBeeToken as GetBeeTokenQuery,
    GetBeeTokenVariables as GetBeeTokenQueryVariables,
} from 'nutshell-graphql-types';

import GET_BEE_TOKEN from '../queries/get-bee-token.graphql';

export function useGetBeeToken(product: string): {
    beeToken: string | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading} = useQuery<GetBeeTokenQuery, GetBeeTokenQueryVariables>(
        GET_BEE_TOKEN,
        {
            variables: {input: product},
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        beeToken: data ? data.beeToken : undefined,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
